import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=444e3ba1&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=444e3ba1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444e3ba1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('444e3ba1')) {
      api.createRecord('444e3ba1', component.options)
    } else {
      api.reload('444e3ba1', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=444e3ba1&scoped=true&", function () {
      api.rerender('444e3ba1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/arbitrator/arbInquiry/detail.vue"
export default component.exports